import React from 'react';
import {observer} from 'mobx-react';
import {Button} from 'shared/components/buttons';
import {FormattedMessage} from 'react-intl';
import {redirect} from 'shared/tools';

const ExpenseTask = observer(({uiState}) => {
  const {task} = uiState;

  return (
    <div>
      <div className='mb3 jumbo'>
        <FormattedMessage id='inbox.You have been assigned an expense request to review. View the request to approve or reject it.'/>
      </div>
      {task.assignedToCurrentUser && !task.completed &&
        <Button onClick={() => redirect(`/expenses/expense_requests/${task.relatedTo.id}`)}>
          <FormattedMessage id='inbox.View Expense Request'/>
        </Button>}
    </div>
  );
});

export default ExpenseTask;
